import React, { useState, useRef } from 'react';
import { Box, CircularProgress, Typography, Popper, Paper, Button } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import CloseIcon from '@mui/icons-material/Close';
import { useGetAllCustomersStructureQuery, useGetFolderStructureQuery } from '../../../../../services/graphApi';
import { FolderItem } from '../../../../../types/graph';
import { CustomerFolderStructure } from '../FolderStructure/CustomerFolderStructure';

interface ActiveCompanyTreeViewProps {
	onFileSelect?: (file: FolderItem) => void;
	customerName: string;
}

export const ActiveCompanyTreeView: React.FC<ActiveCompanyTreeViewProps> = ({ onFileSelect, customerName }) => {
	const [open, setOpen] = useState(false);
	const anchorEl = useRef<HTMLDivElement>(null);
	const { data: customers, isLoading: isCustomersLoading, isFetching: isCustomersFetching } = useGetAllCustomersStructureQuery();

	const findCustomerByName = (name: string) => {
		if (!name) return null;

		if (!customers?.children) return null;
		name = name.toLowerCase().replace('oy', '').trim();

		return customers.children.find((customer: any) => customer.name.toLowerCase().startsWith(name));
	};

	const foundFolderName = findCustomerByName(customerName);

	const {
		data: singleCustomer,
		isLoading: isSingleCustomerLoading,
		isFetching: isSingleCustomerFetching,
	} = useGetFolderStructureQuery({ customerName: foundFolderName?.name ?? '' }, { skip: !customerName || !foundFolderName });

	if (!foundFolderName) {
		return null;
	}

	return (
		<>
			<Box ref={anchorEl}>
				{isSingleCustomerLoading || isSingleCustomerFetching ? (
					<Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
						<CircularProgress size={24} />
					</Box>
				) : (
					<Button
						onClick={() => setOpen(!open)}
						variant='text'
						startIcon={open ? <CloseIcon /> : <FolderIcon />}
						aria-expanded={open}
						aria-haspopup='true'
					>
						{foundFolderName.name}
					</Button>
				)}
			</Box>
			<Popper
				open={open}
				anchorEl={anchorEl.current}
				placement='bottom-start'
				modifiers={[
					{
						name: 'offset',
						options: {
							offset: [0, 8],
						},
					},
				]}
			>
				<Paper elevation={3} sx={{ p: 2, maxHeight: '400px', overflow: 'auto' }}>
					{singleCustomer && (
						<CustomerFolderStructure item={singleCustomer} onFileSelect={onFileSelect} expandFirstLevel={true} />
					)}
				</Paper>
			</Popper>
		</>
	);
};
